import * as React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import {Button} from '@foundit/ui-library';
import Modal from '@mui/material/Modal';
import styled from '@emotion/styled';
import { COLOR_MAP } from '../../constants/ColorNames';

type ModalProps = {
    open: boolean,
    handleClose: () => void,
    handleOpen?: () => void,
    heading: string,
    content: React.ReactNode,
    action: string,
    cancelAction?: string,
    handleAction: () => void,
    dimensions?: { height: number, width: number },
    styles?: { minHeight?: string},
    loading?: boolean,
    flipCTA?: boolean,
    flipActions?: boolean,
    headerIcon?: React.ReactNode,
}

// const ModalContainer = styled(Box)`
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     min-width: 36rem;
//     min-height: 20rem;
//     border-radius: 1.6rem;
//     background-color: ${COLOR_MAP.WHITE};
//     width: ${(props) => props.dimensions ? `${props.dimensions.width}px` : '100%'};
// `

type ModalContainerProps = BoxProps & {
    dimensions?: { height: number, width: number },
    styles?: { minHeight?: string}
};

const ModalContainer = styled(Box)((props: ModalContainerProps) => ({
    fontFamily: 'Noto Sans',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '36rem',
    minHeight: '20rem',
    borderRadius: '1.6rem',
    backgroundColor: COLOR_MAP.WHITE,
    ...(props.dimensions && {
        height: `${props.dimensions.height}px`,
        width: `${props.dimensions.width}px`,
    }),
    ...(props.styles && {
        ...props.styles
    }),
}));


const Heading = styled.span`
    padding: 1.6rem;
    border-bottom: 0.1rem solid ${COLOR_MAP.DISABLED};
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${COLOR_MAP.BLACK};
    display: flex;
`

const Content = styled.span`
    padding: 0 1.6rem;
    color: ${COLOR_MAP.GREY_2};
    font-weight: 400;
    font-size: 1.4rem;
    line-height:2rem;
    display: flex;
`

const ButtonContainer = styled.div`
    display: flex;
    align-items: inherit;
    position: absolute;
    bottom: 11px;
    justify-content: space-around;
    width: 100%;
    box-shadow: 0 -2px 5px -6px #000;
    padding-top: 1rem;
    & .MuiButtonBase-root {
    text-transform: none;
  }
`
const BasicModal = (props: ModalProps) => {
    const { open, dimensions, styles, handleClose, handleOpen, heading, content, action, handleAction, loading = false, flipCTA = false, flipActions = false, cancelAction = '', headerIcon} = props

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <ModalContainer dimensions={dimensions} styles={styles}>
                <Heading>
                    {headerIcon ? headerIcon : null}
                    {heading}
                </Heading>
                <Content>
                    {content}
                </Content>
                <ButtonContainer>
                    {!flipActions && (<Button disabled={loading} sx={{ padding: 0, width: "42.5%" }} onClick={handleClose} type={flipCTA ? 'contained_main' : 'text'}>{cancelAction ? cancelAction : 'Cancel'}</Button>)}
                    <Button disabled={loading} sx={{ padding: '1.2rem 1.6rem', width: "42.5%" }} onClick={handleAction} type={flipCTA ? 'text' : 'contained_main'}>{action}</Button>
                    {flipActions && (<Button disabled={loading} sx={{ padding: 0, width: "42.5%" }} onClick={handleClose} type={flipCTA ? 'contained_main' : 'text'}>{cancelAction ? cancelAction : 'Cancel'}</Button>)}
                </ButtonContainer>
            </ModalContainer>
        </Modal>

    );
}

export default BasicModal